export const CALENDAR_TASK_DISPLAY_TITLE_PREFIX = {
  REMINDER: 'Reminder:',
  DEADLINE: 'Deadline:',
} as const;
